import { Autocomplete, TextField } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { AutocompleteTagChip } from "./autocomplete-tag-chip"

export function ConditionValueSetPicker({ value, onChange, options, placeholder, freeSolo }) {
    const selected = Array.isArray(value) ? value : value ? [value] : []

    return (
        <Autocomplete
            multiple
            freeSolo={!!freeSolo}
            options={options || []}
            value={selected}
            onChange={handleChange}
            renderTags={renderTags}
            renderInput={(params) => <TextField {...params} placeholder={placeholder || "Select..."} />}
        />
    )

    function handleChange(_, newValue) {
        onChange(newValue)
    }

    function renderTags(tagValue, getTagProps) {
        return <Repeat list={tagValue} item={<AutocompleteTagChip getTagProps={getTagProps} />} />
    }
}
